import { ChevronRight } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";

import {
  Item,
  ItemActions,
  ItemContent,
  ItemGroup,
  ItemTitle,
} from "@/components/ui/item";

import { FinancePage } from "./FinancePage";

const LINKS = [
  { to: FinancePage.path, label: "crm.finance.tabs.overview" },
  { to: `${FinancePage.path}/contracts`, label: "crm.finance.tabs.contracts" },
  { to: `${FinancePage.path}/charges`, label: "crm.finance.tabs.charges" },
  { to: `${FinancePage.path}/expenses`, label: "crm.finance.tabs.expenses" },
];

/** Mobile entry points of the finance tabs (Settings page) */
export const FinanceMobileLinks = () => {
  const translate = useTranslate();
  return (
    <ItemGroup className="overflow-hidden rounded-lg border">
      {LINKS.map((link) => (
        <Item key={link.to} asChild size="sm" className="cursor-pointer">
          <Link to={link.to}>
            <ItemContent>
              <ItemTitle className="font-normal">
                {translate(link.label)}
              </ItemTitle>
            </ItemContent>
            <ItemActions>
              <ChevronRight className="size-4 text-muted-foreground" />
            </ItemActions>
          </Link>
        </Item>
      ))}
    </ItemGroup>
  );
};
